<template>
  <p>
    {{ text('context_info.INN.p1') }}
  </p>
  <p>
    {{ text('context_info.INN.p2') }}
  </p>
  <p>
    {{ text('context_info.INN.p3') }}
  </p>
  <p>
    {{ text('context_info.INN.p4') }}
  </p>
  <hr />
  <!-- <p class="mt-3">
    <span class="text-cyan-400">***{{ text('context_info.tip_for_beginners') }}*** </span>
    <span>{{ text('context_info.INN.p5') }}</span>
  </p> -->
</template>

<script setup>
import text from '~/text';
</script>
